import React from "react";
import images from "../../data/images";
// import images from "../../data/images";
import {
  CenterLine,
  Roadmap,
  RoadMapBox,
  RoadMapBoxItem,
  RoadMapBoxItemText,
  RoadMapContent,
  RoadMapDivider,
  RoadMapDividerWrapper,
  RoadMapSpan,
  StickyIcon,
  StickyIconImg,
} from "./roadmapStyle";

const RoadMap = () => {
  return (
    <Roadmap>
      <CenterLine>
        <StickyIcon>
          <StickyIconImg src={images.logo} alt="" />
        </StickyIcon>
      </CenterLine>
      <RoadMapContent>
        <RoadMapBox>
          <RoadMapSpan>01</RoadMapSpan>
          <RoadMapDividerWrapper>
            <RoadMapDivider />
          </RoadMapDividerWrapper>
          <RoadMapBoxItem>
            <RoadMapBoxItemText>
              Welcome to the best preserved place on earth! Every Meta Lion in
              the Kingdom is a best of the best 4K 3D hand drawn art piece by a
              talented trio of seasoned artists. If their past experiences and
              successes do not convince you that they mean business we don't
              know what will. But…. a kingdom is nothing without its lions.
              Together we will create a strong community that will not just feel
              like family, it will feel like ROYAL FAMILY!
            </RoadMapBoxItemText>
          </RoadMapBoxItem>
        </RoadMapBox>
        <RoadMapBox>
          <RoadMapSpan>02</RoadMapSpan>
          <RoadMapDividerWrapper>
            <RoadMapDivider />
          </RoadMapDividerWrapper>
          <RoadMapBoxItem>
            <RoadMapBoxItemText>
              Welcome to the best preserved place on earth! Every Meta Lion in
              the Kingdom is a best of the best 4K 3D hand drawn art piece by a
              talented trio of seasoned artists. If their past experiences and
              successes do not convince you that they mean business we don't
              know what will. But…. a kingdom is nothing without its lions.
              Together we will create a strong community that will not just feel
              like family, it will feel like ROYAL FAMILY!
            </RoadMapBoxItemText>
          </RoadMapBoxItem>
        </RoadMapBox>
        <RoadMapBox>
          <RoadMapSpan>03</RoadMapSpan>
          <RoadMapDividerWrapper>
            <RoadMapDivider />
          </RoadMapDividerWrapper>
          <RoadMapBoxItem>
            <RoadMapBoxItemText>
              Welcome to the best preserved place on earth! Every Meta Lion in
              the Kingdom is a best of the best 4K 3D hand drawn art piece by a
              talented trio of seasoned artists. If their past experiences and
              successes do not convince you that they mean business we don't
              know what will. But…. a kingdom is nothing without its lions.
              Together we will create a strong community that will not just feel
              like family, it will feel like ROYAL FAMILY!
            </RoadMapBoxItemText>
          </RoadMapBoxItem>
        </RoadMapBox>
        <RoadMapBox>
          <RoadMapSpan>04</RoadMapSpan>
          <RoadMapDividerWrapper>
            <RoadMapDivider />
          </RoadMapDividerWrapper>
          <RoadMapBoxItem>
            <RoadMapBoxItemText>
              Welcome to the best preserved place on earth! Every Meta Lion in
              the Kingdom is a best of the best 4K 3D hand drawn art piece by a
              talented trio of seasoned artists. If their past experiences and
              successes do not convince you that they mean business we don't
              know what will. But…. a kingdom is nothing without its lions.
              Together we will create a strong community that will not just feel
              like family, it will feel like ROYAL FAMILY!
            </RoadMapBoxItemText>
          </RoadMapBoxItem>
        </RoadMapBox>
        <RoadMapBox>
          <RoadMapSpan>05</RoadMapSpan>
          <RoadMapDividerWrapper>
            <RoadMapDivider />
          </RoadMapDividerWrapper>
          <RoadMapBoxItem>
            <RoadMapBoxItemText>
              Welcome to the best preserved place on earth! Every Meta Lion in
              the Kingdom is a best of the best 4K 3D hand drawn art piece by a
              talented trio of seasoned artists. If their past experiences and
              successes do not convince you that they mean business we don't
              know what will. But…. a kingdom is nothing without its lions.
              Together we will create a strong community that will not just feel
              like family, it will feel like ROYAL FAMILY!
            </RoadMapBoxItemText>
          </RoadMapBoxItem>
        </RoadMapBox>
        <RoadMapBox>
          <RoadMapSpan>06</RoadMapSpan>
          <RoadMapDividerWrapper>
            <RoadMapDivider />
          </RoadMapDividerWrapper>
          <RoadMapBoxItem>
            <RoadMapBoxItemText>
              Welcome to the best preserved place on earth! Every Meta Lion in
              the Kingdom is a best of the best 4K 3D hand drawn art piece by a
              talented trio of seasoned artists. If their past experiences and
              successes do not convince you that they mean business we don't
              know what will. But…. a kingdom is nothing without its lions.
              Together we will create a strong community that will not just feel
              like family, it will feel like ROYAL FAMILY!
            </RoadMapBoxItemText>
          </RoadMapBoxItem>
        </RoadMapBox>
      </RoadMapContent>
    </Roadmap>
  );
};

export default RoadMap;
